export default __webpack_public_path__ + "static/media/promo-undesirable-no-1_02.2d760543.jpg";